export default __webpack_public_path__ + "static/media/2.43188b7d.jpg";